<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">填报与录取时间</span>
          </div>
        </div>

      </div>
      <div style="width: 90%;height: 78%;overflow-y: auto;margin: 0 auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column prop="time" label="时间" align="center">
          </el-table-column>
          <el-table-column prop="contents" label="内容" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { tianbaoyu } from "@/api/gw/zonghe.js";
export default {
  data() {
    return {
      list:[],
      loading:false
    };
  },
  mounted() {
    this.tianbaoyu();
  },
  methods: {
    tianbaoyu(){
      this.loading = false
      tianbaoyu({}).then(res=>{
        this.list = res.data
      }).finally(()=>{
        this.loading = false
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/components/tianbao.vue